import { render, staticRenderFns } from "./teamMember-v2.vue?vue&type=template&id=1cd0ea5e&scoped=true&"
import script from "./teamMember-v2.vue?vue&type=script&lang=js&"
export * from "./teamMember-v2.vue?vue&type=script&lang=js&"
import style0 from "./teamMember-v2.vue?vue&type=style&index=0&id=1cd0ea5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0ea5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd0ea5e')) {
      api.createRecord('1cd0ea5e', component.options)
    } else {
      api.reload('1cd0ea5e', component.options)
    }
    module.hot.accept("./teamMember-v2.vue?vue&type=template&id=1cd0ea5e&scoped=true&", function () {
      api.rerender('1cd0ea5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83lxCq9rDfx75/JS/teamMember-v2.vue"
export default component.exports